import ng from 'angular';
import { IProcessoAvaliadorListResponse } from '../../models/processo-avaliador.model';

export class ConfigurarLoteModalController implements ng.IController {
    static $inject = [
        'NewToaster',
        '$uibModalInstance',
        'defaultProcesso'
    ];

    public semAvaliadores: boolean = true;
    public avaliador1: any;
    public avaliador2: any;

    constructor(
        public NewToaster: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        defaultProcesso: IProcessoAvaliadorListResponse | null,
    ) {
        this.applyDefaults(defaultProcesso);
    }

    public confirmar(): void {
        const payload = {
            semAvaliadores: this.semAvaliadores,
            avaliador1: this.semAvaliadores ? null : this.avaliador1,
            avaliador2: this.semAvaliadores ? null : this.avaliador2,
        };

        this.$uibModalInstance.close(payload);
    }

    public close(): void {
        this.$uibModalInstance.dismiss('fechar');
    }

    private applyDefaults(defaultProcesso: IProcessoAvaliadorListResponse | null): void {
        if (!defaultProcesso) {
            return;
        }

        this.semAvaliadores = !!defaultProcesso.semavaliador;

        if (this.semAvaliadores) {
            this.avaliador1 = null;
            this.avaliador2 = null;
            return;
        }

        if (defaultProcesso.gestoravaliador1) {
            this.avaliador1 = { equipe: null, codigo: '__GESTOR__', titulo: 'Gestor' };
        } else if (defaultProcesso.avaliador1) {
            this.avaliador1 = ng.copy(defaultProcesso.avaliador1);
        }

        this.avaliador2 = defaultProcesso.avaliador2 ? ng.copy(defaultProcesso.avaliador2) : null;
    }
}
